import React, { useEffect, useState } from 'react';

const VendorStyles = () => (
  <style>{`
    :root { scroll-behavior: smooth; }
    body { font-family: 'Inter', sans-serif; background-color: #f8fafc; color: #0f172a; overflow-x: hidden; }
    @keyframes slideUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-slide-up {
      opacity: 0;
      animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }
    .delay-100 { animation-delay: 0.1s; }
    .delay-200 { animation-delay: 0.2s; }
    .delay-300 { animation-delay: 0.3s; }
    
    .saas-shadow {
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
    }
    .saas-shadow-hover:hover {
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      transform: translateY(-4px);
    }
    
    /* Clean grid background for hero */
    .bg-grid {
      background-size: 40px 40px;
      background-image: linear-gradient(to right, #f1f5f9 1px, transparent 1px), linear-gradient(to bottom, #f1f5f9 1px, transparent 1px);
    }
  `}</style>
);

const Icons = {
  Terminal: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
  Zap: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" /></svg>,
  Monitor: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" /></svg>,
  ArrowRight: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" /></svg>,
  Check: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-4 h-4 text-emerald-500"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>,
  Wallet: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3" /></svg>,
  Chart: () => <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" /></svg>
};

const VendorProgramLanding = () => {
  const [currency, setCurrency] = useState('USD');
  const [showModal, setShowModal] = useState(false);
  const [selectedTier, setSelectedTier] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', company: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const EXCHANGE_RATE = 83; // 1 USD = 83 INR

  const convertPrice = (usdPrice) => {
    if (currency === 'USD') return usdPrice;
    return Math.round(usdPrice * EXCHANGE_RATE);
  };

  const formatPrice = (price) => {
    if (currency === 'USD') {
      return `$${price.toLocaleString('en-US', { minimumFractionDigits: price < 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
    } else {
      return `₹${price.toLocaleString('en-IN', { minimumFractionDigits: 0 })}`;
    }
  };

  // User Agent Parser
  const parseUserAgent = (ua) => {
    let browser = 'Unknown';
    let version = '';
    let os = 'Unknown';

    if (ua.includes('Chrome')) {
      browser = 'Chrome';
      version = ua.match(/Chrome\/(\d+)/)?.[1] || '';
    } else if (ua.includes('Safari')) {
      browser = 'Safari';
      version = ua.match(/Version\/(\d+)/)?.[1] || '';
    } else if (ua.includes('Firefox')) {
      browser = 'Firefox';
      version = ua.match(/Firefox\/(\d+)/)?.[1] || '';
    } else if (ua.includes('Edge')) {
      browser = 'Edge';
      version = ua.match(/Edge\/(\d+)/)?.[1] || '';
    }

    if (ua.includes('Windows')) os = 'Windows';
    else if (ua.includes('Mac')) os = 'macOS';
    else if (ua.includes('X11')) os = 'Linux';
    else if (ua.includes('Android')) os = 'Android';
    else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';

    return { browser, version, os };
  };

  // Get device metadata
  const getUserMetadata = () => {
    const ua = navigator.userAgent;
    const parser = parseUserAgent(ua);
    return {
      userAgent: ua,
      browser: parser.browser,
      version: parser.version,
      os: parser.os,
      screen: `${window.screen.width}x${window.screen.height}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language: navigator.language,
      platform: navigator.platform,
    };
  };

  // Fetch geolocation from ipapi.co
  const fetchGeolocation = async () => {
    try {
      const response = await fetch('https://ipapi.co/json/', { cache: 'no-store' });
      const data = await response.json();
      return {
        ip: data.ip,
        country: data.country_name,
        city: data.city,
        region: data.region,
        timezone: data.timezone,
        isp: data.org,
      };
    } catch (error) {
      console.warn('Geolocation fetch failed:', error);
      return { ip: 'N/A', country: 'N/A', city: 'N/A', error: true };
    }
  };

  // Handle tier application with metadata
  const handleTierApplication = async (tierInfo) => {
    setSelectedTier(tierInfo);
    setShowModal(true);
  };

  // Submit application form
  const handleSubmitApplication = async () => {
    if (!formData.name || !formData.email) {
      alert('Please fill in Name and Email fields');
      return;
    }

    setIsSubmitting(true);
    try {
      const metadata = getUserMetadata();
      const geoData = await fetchGeolocation();

      const emailBody = `VENDOR APPLICATION FORM
==========================

APPLICANT INFORMATION
==========================
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone || 'N/A'}
Company: ${formData.company || 'N/A'}

MESSAGE
==========================
${formData.message || 'No additional message provided'}

---

VENDOR TIER APPLICATION
==========================
Tier: ${selectedTier.name}
Deposit Amount: ${selectedTier.amount}
Application Date: ${new Date().toLocaleString()}

APPLICANT METADATA
==========================
IP Address: ${geoData.ip || 'N/A'}
Location: ${geoData.city || 'N/A'}, ${geoData.country || 'N/A'}
Timezone: ${geoData.timezone || 'N/A'}
${geoData.isp ? `ISP: ${geoData.isp}\n` : ''}
DEVICE INFORMATION
==========================
Operating System: ${metadata.os}
Browser: ${metadata.browser} v${metadata.version || 'Unknown'}
Screen Resolution: ${metadata.screen}
Language: ${metadata.language}
Platform: ${metadata.platform}
Device Type: ${/Mobile|Android|iPhone/.test(metadata.userAgent) ? 'Mobile' : 'Desktop'}
User Agent: ${metadata.userAgent}

---
Submitted via CheckScript Vendor Portal`;

      const encodedBody = encodeURIComponent(emailBody);
      const subject = encodeURIComponent(`${selectedTier.name} Application - ${formData.name}`);

      // Open email client with pre-filled data
      window.location.href = `mailto:checkscript.site@gmail.com?subject=${subject}&body=${encodedBody}`;

      // Reset form and close modal
      setShowModal(false);
      setFormData({ name: '', email: '', phone: '', company: '', message: '' });
    } catch (error) {
      console.error('Error processing application:', error);
      alert('Error processing application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll('.animate-trigger');
    elements.forEach((el, i) => setTimeout(() => el.classList.add('animate-slide-up'), i * 150));
  }, []);

  return (
    <div className="bg-slate-50 min-h-screen">
      <VendorStyles />
      
      {/* Clean B2B Navbar */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
            <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded bg-indigo-600 flex items-center justify-center font-bold text-white shadow-sm">CS</div>
                <h1 className="text-xl font-bold text-slate-900 tracking-tight">CheckScript <span className="text-slate-500 font-normal">Partners</span></h1>
            </div>
            <div className="flex gap-4 items-center">
              <div className="flex gap-2 bg-slate-100 rounded-lg p-1">
                <button
                  onClick={() => setCurrency('USD')}
                  className={`px-3 py-1.5 rounded text-sm font-semibold transition-all ${
                    currency === 'USD'
                      ? 'bg-white text-indigo-600 shadow-sm'
                      : 'text-slate-600 hover:text-slate-900'
                  }`}
                >
                  USD
                </button>
                <button
                  onClick={() => setCurrency('INR')}
                  className={`px-3 py-1.5 rounded text-sm font-semibold transition-all ${
                    currency === 'INR'
                      ? 'bg-white text-indigo-600 shadow-sm'
                      : 'text-slate-600 hover:text-slate-900'
                  }`}
                >
                  INR
                </button>
              </div>
              <a href="/vendor/activate" className="text-sm font-medium text-slate-600 hover:text-slate-900 hidden sm:block">Vendor Login</a>
              <a href="#pricing" className="text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 px-5 py-2.5 rounded-lg shadow-sm transition-colors">Apply to Resell</a>
            </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative pt-24 pb-20 px-6 bg-grid">
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 to-slate-50/90 pointer-events-none"></div>
        <div className="container mx-auto max-w-4xl text-center relative z-10">
            <div className="inline-block mb-6 px-4 py-1.5 bg-indigo-50 border border-indigo-100 rounded-full text-indigo-700 text-xs font-bold tracking-widest uppercase animate-trigger">
                B2B Wholesale Program
            </div>
            <h2 className="text-5xl md:text-6xl font-black text-slate-900 leading-tight mb-6 animate-trigger">
                Build your business on <br/>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-sky-500">our infrastructure.</span>
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-10 leading-relaxed animate-trigger">
                Purchase CheckScript licenses at massive wholesale discounts and resell them to your local market. You set the price, you manage your clients, and you keep 100% of the margins.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 animate-trigger">
                <a href="#the-math" className="px-8 py-3.5 rounded-xl font-semibold text-slate-700 bg-white hover:bg-slate-50 border border-slate-200 saas-shadow transition-all">
                    See The Profit Math
                </a>
                <a href="#pricing" className="px-8 py-3.5 rounded-xl font-semibold text-white bg-indigo-600 hover:bg-indigo-700 saas-shadow flex items-center justify-center gap-2 transition-all">
                    View Wholesale Tiers <Icons.ArrowRight />
                </a>
            </div>
        </div>
      </section>

      {/* The Math Section (Demonstrating massive ROI) */}
      <section id="the-math" className="py-24 bg-white border-y border-slate-200">
        <div className="container mx-auto px-6 max-w-5xl">
            <div className="text-center mb-16 animate-trigger">
                <div className="inline-flex items-center gap-2 mb-4 px-4 py-1.5 bg-emerald-50 border border-emerald-200 rounded-full text-emerald-700 text-xs font-bold uppercase tracking-widest">
                    <Icons.Chart /> Up to 200%+ ROI
                </div>
                <h3 className="text-3xl font-bold text-slate-900 mb-4">What exactly does a deposit buy?</h3>
                <p className="text-slate-600 max-w-2xl mx-auto">Unlike fixed packages, you buy "Wallet Credits". You decide exactly how to spend them based on what your customers want. Here is an example of the profits from a <strong>{formatPrice(convertPrice(180))}</strong> (Pro Tier) deposit.</p>
            </div>

            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-8 saas-shadow animate-trigger">
                <div className="flex flex-col md:flex-row gap-8 items-center">
                    
                    {/* The Example Breakdown (Using Pro Tier Pricing) */}
                    <div className="flex-1 space-y-6 w-full">
                        <div className="flex items-center gap-3 border-b border-slate-200 pb-4">
                            <div className="bg-indigo-100 text-indigo-600 p-2 rounded-lg"><Icons.Terminal /></div>
                            <div className="flex-1">
                                <p className="text-sm font-bold text-slate-900">1,000 API Questions</p>
                                <p className="text-xs text-slate-500">Cost you: {formatPrice(convertPrice(4.50))} ({formatPrice(convertPrice(0.005))}/ea)</p>
                            </div>
                            <div className="text-right">
                                <p className="text-xs text-slate-500">You sell for</p>
                                <p className="text-sm font-bold text-emerald-600">{formatPrice(convertPrice(12))}</p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3 border-b border-slate-200 pb-4">
                            <div className="bg-violet-100 text-violet-600 p-2 rounded-lg"><Icons.Zap /></div>
                            <div className="flex-1">
                                <p className="text-sm font-bold text-slate-900">50 Premium Passes</p>
                                <p className="text-xs text-slate-500">Cost you: {formatPrice(convertPrice(45))} ({formatPrice(convertPrice(0.90))}/ea)</p>
                            </div>
                            <div className="text-right">
                                <p className="text-xs text-slate-500">You sell for</p>
                                <p className="text-sm font-bold text-emerald-600">{formatPrice(convertPrice(120))}</p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3 pb-2">
                            <div className="bg-cyan-100 text-cyan-600 p-2 rounded-lg"><Icons.Monitor /></div>
                            <div className="flex-1">
                                <p className="text-sm font-bold text-slate-900">30 Days of RDP Access</p>
                                <p className="text-xs text-slate-500">Cost you: {formatPrice(convertPrice(80))} ({formatPrice(convertPrice(2.65))}/ea)</p>
                            </div>
                            <div className="text-right">
                                <p className="text-xs text-slate-500">You sell for</p>
                                <p className="text-sm font-bold text-emerald-600">{formatPrice(convertPrice(216))}</p>
                            </div>
                        </div>
                    </div>

                    {/* The ROI Summary Box */}
                    <div className="w-full md:w-80 bg-white border border-slate-200 rounded-xl p-6 saas-shadow text-center relative overflow-hidden">
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-400 to-emerald-600"></div>
                        <p className="text-sm font-medium text-slate-500 mb-1">Your Initial Deposit</p>
                        <p className="text-3xl font-black text-slate-900 mb-6">{formatPrice(convertPrice(179))}</p>

                        <p className="text-sm font-medium text-slate-500 mb-1">Total Retail Value</p>
                        <p className="text-2xl font-bold text-slate-900 mb-6">{formatPrice(convertPrice(481))}</p>

                        <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 shadow-sm">
                            <p className="text-xs font-bold text-emerald-800 uppercase tracking-wider mb-1">Pure Profit Generated</p>
                            <p className="text-2xl font-black text-emerald-600 mb-1">{formatPrice(convertPrice(302))}</p>
                            <p className="text-xs font-bold text-emerald-700 bg-emerald-200/50 inline-block px-2 py-0.5 rounded">168% ROI</p>
                        </div>
                        <p className="text-[10px] text-slate-400 mt-4 leading-tight">*Example based on Pro Tier pricing. You keep 100% of the revenue collected from your users.</p>
                    </div>

                </div>
            </div>
        </div>
      </section>

      {/* How it Works / The Dashboard */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-6 max-w-5xl">
            <div className="grid md:grid-cols-2 gap-16 items-center animate-trigger">
                <div>
                    <h3 className="text-3xl font-bold text-slate-900 mb-8">Secure, direct distribution.</h3>
                    <div className="space-y-8">
                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold flex-shrink-0">1</div>
                            <div>
                                <h5 className="text-slate-900 font-bold text-lg mb-1">Deposit Funds</h5>
                                <p className="text-slate-600 text-sm leading-relaxed">Deposit funds to receive your Master Key. Your key acts as a secure digital vault for your wholesale inventory.</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold flex-shrink-0">2</div>
                            <div>
                                <h5 className="text-slate-900 font-bold text-lg mb-1">Collect Payments Directly</h5>
                                <p className="text-slate-600 text-sm leading-relaxed">A student pays you the retail price (e.g., {formatPrice(convertPrice(2.40))} via card or cash). You keep the money directly. No platform fees or revenue sharing.</p>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-bold flex-shrink-0">3</div>
                            <div>
                                <h5 className="text-slate-900 font-bold text-lg mb-1">Activate Their Account</h5>
                                <p className="text-slate-600 text-sm leading-relaxed">Log into the Vendor Portal. You input an internal activation code, your Master Key, and the user's Device ID. The system deducts the wholesale cost from your wallet and unlocks their app instantly. <strong className="text-slate-800">You never hand codes directly to customers.</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Clean UI Mockup */}
                <div className="bg-white rounded-2xl border border-slate-200 p-6 saas-shadow-hover transition-all">
                    <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-100">
                        <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-600"><Icons.Wallet /></div>
                        <div className="flex-1">
                            <div className="text-sm font-bold text-slate-900">Vendor Dashboard</div>
                            <div className="text-xs text-slate-500">Live Inventory</div>
                        </div>
                    </div>
                    <div className="space-y-4">
                        <div className="bg-slate-50 rounded-lg p-3 flex justify-between items-center border border-slate-100">
                            <span className="text-sm text-slate-600 font-medium">Questions Limit</span>
                            <span className="text-indigo-600 font-mono font-bold">1,450 left</span>
                        </div>
                        <div className="bg-slate-50 rounded-lg p-3 flex justify-between items-center border border-slate-100">
                            <span className="text-sm text-slate-600 font-medium">Premium Passes</span>
                            <span className="text-violet-600 font-mono font-bold">42 left</span>
                        </div>
                        <div className="bg-slate-50 rounded-lg p-3 flex justify-between items-center border border-slate-100">
                            <span className="text-sm text-slate-600 font-medium">RDP Time Allocation</span>
                            <span className="text-cyan-600 font-mono font-bold">168 Hours</span>
                        </div>
                    </div>
                    <button className="w-full mt-6 py-3 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors">
                        Activate New User
                    </button>
                </div>
            </div>
        </div>
      </section>

      {/* Wholesale Pricing Tiers */}
      <section id="pricing" className="py-24 bg-white border-t border-slate-200">
        <div className="container mx-auto px-6 max-w-6xl">
            <div className="text-center mb-16 animate-trigger">
                <h3 className="text-3xl font-bold text-slate-900 mb-4">Wholesale Deposit Tiers</h3>
                <p className="text-slate-600 max-w-2xl mx-auto">The more funds you deposit into your wallet, the cheaper your wholesale rate becomes, multiplying your profits.</p>
                <p className="text-xs text-slate-400 mt-3 font-medium">*All vendors are subject to a one-time {formatPrice(convertPrice(12))} setup fee to generate a Master Key.</p>
                <p className="text-xs text-slate-500 mt-4 italic">📍 We collect your device location & browser info to process applications faster.</p>
            </div>

            <div className="grid lg:grid-cols-3 gap-8">
                {/* Tier 1 */}
                <div className="bg-white border border-slate-200 rounded-3xl p-8 saas-shadow-hover flex flex-col animate-trigger">
                    <h4 className="text-2xl font-bold text-slate-900 mb-2">Starter Tier</h4>
                    <p className="text-slate-500 text-sm mb-6 h-10">Perfect for testing your local college network.</p>
                    <div className="text-4xl font-black text-slate-900 mb-8">{formatPrice(convertPrice(60))}<span className="text-base text-slate-500 font-normal"> deposit</span></div>

                    <div className="space-y-4 flex-grow mb-8 text-sm">
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-600">Cost per Question</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(0.08))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(0.15))})</span></span>
                        </div>
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-600">Premium Pass</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(1.20))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(2.40))})</span></span>
                        </div>
                        <div className="flex justify-between pb-2">
                            <span className="text-slate-600">RDP (1 Day)</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(3.60))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(7.20))})</span></span>
                        </div>
                    </div>
                    <a href="#" onClick={(e) => { e.preventDefault(); handleTierApplication({ name: 'Starter Tier', amount: formatPrice(convertPrice(60)) }); }} className="w-full py-3.5 rounded-xl font-semibold text-indigo-600 text-center bg-indigo-50 hover:bg-indigo-100 transition-colors border border-indigo-100 cursor-pointer">Apply for Starter</a>
                </div>

                {/* Tier 2 */}
                <div className="bg-white border-2 border-indigo-600 rounded-3xl p-8 saas-shadow-hover flex flex-col relative transform lg:-translate-y-4 animate-trigger shadow-indigo-500/10">
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-indigo-600 text-white px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider">Most Popular</div>
                    <h4 className="text-2xl font-bold text-indigo-700 mb-2">Pro Tier</h4>
                    <p className="text-slate-500 text-sm mb-6 h-10">For active sellers managing groups and channels.</p>
                    <div className="text-4xl font-black text-slate-900 mb-8">{formatPrice(convertPrice(180))}<span className="text-base text-slate-500 font-normal"> deposit</span></div>

                    <div className="space-y-4 flex-grow mb-8 text-sm">
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-600">Cost per Question</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(0.05))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(0.15))})</span></span>
                        </div>
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-600">Premium Pass</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(0.90))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(2.40))})</span></span>
                        </div>
                        <div className="flex justify-between pb-2">
                            <span className="text-slate-600">RDP (1 Day)</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(2.65))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(7.20))})</span></span>
                        </div>
                    </div>
                    <a href="#" onClick={(e) => { e.preventDefault(); handleTierApplication({ name: 'Pro Tier', amount: formatPrice(convertPrice(180)) }); }} className="w-full py-3.5 rounded-xl font-semibold text-white text-center bg-indigo-600 hover:bg-indigo-700 transition-colors shadow-sm cursor-pointer">Apply for Pro</a>
                </div>

                {/* Tier 3 */}
                <div className="bg-white border border-slate-200 rounded-3xl p-8 saas-shadow-hover flex flex-col animate-trigger">
                    <h4 className="text-2xl font-bold text-slate-900 mb-2">Elite Tier</h4>
                    <p className="text-slate-500 text-sm mb-6 h-10">For serious distributors dominating regional markets.</p>
                    <div className="text-4xl font-black text-slate-900 mb-8">{formatPrice(convertPrice(480))}+<span className="text-base text-slate-500 font-normal"> deposit</span></div>

                    <div className="space-y-4 flex-grow mb-8 text-sm">
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-600">Cost per Question</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(0.04))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(0.15))})</span></span>
                        </div>
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-600">Premium Pass</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(0.60))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(2.40))})</span></span>
                        </div>
                        <div className="flex justify-between pb-2">
                            <span className="text-slate-600">RDP (1 Day)</span>
                            <span className="font-bold text-slate-900">{formatPrice(convertPrice(1.80))} <span className="text-xs text-slate-400 font-normal ml-1">(Retail {formatPrice(convertPrice(7.20))})</span></span>
                        </div>
                    </div>
                    <a href="#" onClick={(e) => { e.preventDefault(); handleTierApplication({ name: 'Elite Tier', amount: formatPrice(convertPrice(480)) }); }} className="w-full py-3.5 rounded-xl font-semibold text-indigo-600 text-center bg-indigo-50 hover:bg-indigo-100 transition-colors border border-indigo-100 cursor-pointer">Apply for Elite</a>
                </div>
            </div>
        </div>
      </section>

      <footer className="bg-slate-900 py-12 text-center border-t border-slate-800">
          <div className="container mx-auto px-6 max-w-4xl">
              <h3 className="text-xl font-bold text-white mb-4">CheckScript Vendor Network</h3>
              <p className="text-slate-400 text-sm mb-8 leading-relaxed max-w-2xl mx-auto">
                  Authorized vendors are independent contractors. CheckScript provides the backend infrastructure and wholesale inventory. Vendors are responsible for their own direct sales, marketing, and local pricing strategies.
              </p>
              <div className="flex justify-center gap-6 text-sm text-slate-300">
                  <a href="/vendor/activate" className="hover:text-white transition-colors font-semibold">Vendor Portal Login</a>
                  <a href="mailto:checkscript.site@gmail.com" className="hover:text-white transition-colors">Contact Admin</a>
              </div>
              <div className="mt-8 text-slate-600 text-xs">
                  &copy; {new Date().getFullYear()} CheckScript. All Rights Reserved.
              </div>
          </div>
      </footer>

      {/* Application Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-8">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-slate-900">Apply for {selectedTier?.name}</h2>
              <button onClick={() => setShowModal(false)} className="text-slate-500 hover:text-slate-900 text-2xl">✕</button>
            </div>

            <p className="text-slate-600 mb-6">Fill in your details below. Your information and device metadata will be included with your application.</p>

            <form className="space-y-5" onSubmit={(e) => { e.preventDefault(); handleSubmitApplication(); }}>
              {/* Name */}
              <div>
                <label className="block text-sm font-semibold text-slate-900 mb-2">Full Name *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Your full name"
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:border-indigo-600 focus:ring-1 focus:ring-indigo-600"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-semibold text-slate-900 mb-2">Email Address *</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="your.email@example.com"
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:border-indigo-600 focus:ring-1 focus:ring-indigo-600"
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-semibold text-slate-900 mb-2">Phone Number</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="+1 (555) 000-0000"
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:border-indigo-600 focus:ring-1 focus:ring-indigo-600"
                />
              </div>

              {/* Company */}
              <div>
                <label className="block text-sm font-semibold text-slate-900 mb-2">Company/Organization</label>
                <input
                  type="text"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  placeholder="Your company name"
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:border-indigo-600 focus:ring-1 focus:ring-indigo-600"
                />
              </div>

              {/* Message */}
              <div>
                <label className="block text-sm font-semibold text-slate-900 mb-2">Additional Message</label>
                <textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  placeholder="Tell us about your business, market, or any questions you have..."
                  rows="4"
                  className="w-full px-4 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:border-indigo-600 focus:ring-1 focus:ring-indigo-600"
                />
              </div>

              {/* Selected Tier Info */}
              <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
                <p className="text-sm text-slate-700">
                  <span className="font-semibold text-slate-900">Tier:</span> {selectedTier?.name}
                </p>
                <p className="text-sm text-slate-700 mt-1">
                  <span className="font-semibold text-slate-900">Deposit Amount:</span> {selectedTier?.amount}
                </p>
              </div>

              {/* Privacy Notice */}
              <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
                <p className="text-xs text-slate-600">
                  📍 Your device information (IP address, location, browser, OS, screen resolution, timezone) will be automatically included with your application to help us process it faster.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 pt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 px-4 py-3 rounded-lg font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex-1 px-4 py-3 rounded-lg font-semibold text-white bg-indigo-600 hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Processing...' : 'Send Application via Email'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorProgramLanding;